<script lang="ts" setup>
import { ref } from "vue";

const props = defineProps({
  right: Boolean,
  size: String,
  density: String,
});

const toggled = ref(false);

function blur() {
  if (toggled.value === true) {
    toggle();
  }
}

function toggle() {
  toggled.value = !toggled.value;
}
</script>
<template>
  <div class="information-popup" :class="{ active: toggled }">
    <v-btn icon="mdi-information" density="compact" variant="text" @click="toggle" v-on:blur="blur()"></v-btn>

    <transition name="fade">
      <article v-show="toggled === true" :class="{ right: props.right, large: props.size === 'large', compact: props.density === 'compact' }">
        <header>
          <slot name="header"></slot>
        </header>

        <section>
          <slot></slot>
        </section>
      </article>
    </transition>
  </div>
</template>

<style scoped>
* {
  transition: background-color 0.2s;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
